import type { ReactNode } from 'react';
import type { RenderSuggestionsContainerParams } from 'react-autosuggest';

import { Box } from '#/components/Box/Box';
import { Image } from '#/components/Image/Image';
import { useAppConfig } from '#/config/AppConfigContext';
import { getStaticImageSrc } from '#/utils/getImageSrc';

type Props = {
  containerProps: RenderSuggestionsContainerParams['containerProps'];
  children: ReactNode;
  loading: boolean;
};

export function SuggestionsContainer({
  containerProps: { id, ref, key, className, role },
  children,
  loading,
}: Props) {
  const { appConfig } = useAppConfig();

  return (
    <div
      id={id}
      ref={ref}
      key={key}
      className={className}
      data-loading={loading}
      role={role}
    >
      {children}
      <Box display="flex" justifyContent="flex-end" mb={8} mr={18}>
        {!loading ? (
          <Image
            height={12}
            src={getStaticImageSrc(
              'poweredbygoogle/powered_by_google_on_white.png',
              appConfig.idealist.staticImgPath,
            )}
            srcSet={`${getStaticImageSrc(
              'poweredbygoogle/powered_by_google_on_white.png',
              appConfig.idealist.staticImgPath,
            )}, ${getStaticImageSrc(
              'poweredbygoogle/powered_by_google_on_white@2x.png',
              appConfig.idealist.staticImgPath,
            )} 2x, ${getStaticImageSrc(
              'poweredbygoogle/powered_by_google_on_white@3x.png',
              appConfig.idealist.staticImgPath,
            )} 3x`}
            alt="Powered by Google"
          />
        ) : null}
      </Box>
    </div>
  );
}
